import { classify } from 'sidecar-utilities'

import { Sentiment } from '@sidecar-components/types'

const bgColor = (sentiment, weight) => {
  switch (sentiment) {
    case Sentiment.ACCENT:
      return 'color-accent-weak-default'
    case Sentiment.ENGAGE:
      return 'color-engage-weak-default'
    case Sentiment.NOTIFY:
      return weight === 'weak'
        ? 'color-bgNotifyContainer'
        : 'color-notify-weak-default'
    case Sentiment.POSITIVE:
      return weight === 'weak'
        ? 'color-bgPositiveContainer'
        : 'color-bgPositive'
    case Sentiment.PRIMARY:
      return weight === 'weak' ? 'color-bgPrimaryContainer' : 'color-bgPrimary'
    case Sentiment.RISK:
      return weight === 'weak'
        ? 'color-bgRiskContainer'
        : 'color-risk-weak-default'
    case Sentiment.DEFAULT:
    default:
      return weight === 'weak'
        ? 'color-bgDefault-disabled'
        : 'color-bgDefaultDecor'
  }
}

const textColor = (sentiment, weight) => {
  switch (sentiment) {
    case Sentiment.ACCENT:
      return 'color-textOnAccent-bold-default'
    case Sentiment.ENGAGE:
      return 'color-textOnEngage-weak-default'
    case Sentiment.NOTIFY:
      return weight === 'weak'
        ? 'color-textOnNotifyContainer'
        : 'color-textOnNotify-bold-default'
    case Sentiment.POSITIVE:
      return weight === 'weak'
        ? 'color-textOnPositiveContainer'
        : 'color-textOnPositive'
    case Sentiment.PRIMARY:
      return weight === 'weak'
        ? 'color-textOnPrimaryContainer'
        : 'color-textOnPrimary'
    case Sentiment.RISK:
      return weight === 'weak'
        ? 'color-textOnRiskContainer'
        : 'color-textOnRisk-bold-default'
    case Sentiment.DEFAULT:
    default:
      return weight === 'weak'
        ? 'color-textOnDefault'
        : 'color-textOnInverse-weak-default'
  }
}

const iconColor = (sentiment, weight) => {
  switch (sentiment) {
    case Sentiment.ACCENT:
      return 'color-iconOnAccent-bold-default'
    case Sentiment.ENGAGE:
      return 'color-iconOnEngage-weak-default'
    case Sentiment.NOTIFY:
      return weight === 'weak'
        ? 'color-iconOnNotifyContainer'
        : 'color-iconOnNotify-default'
    case Sentiment.POSITIVE:
      return weight === 'weak'
        ? 'color-iconOnPositiveContainer'
        : 'color-iconOnPositive'
    case Sentiment.PRIMARY:
      return weight === 'weak'
        ? 'color-iconOnPrimaryContainer'
        : 'color-iconOnPrimary'
    case Sentiment.RISK:
      return weight === 'weak'
        ? 'color-iconOnRiskContainer'
        : 'color-iconOnRisk-bold-default'
    case Sentiment.DEFAULT:
    default:
      return weight === 'weak'
        ? 'color-iconOnDefault'
        : 'color-iconOnInverse-weak-default'
  }
}

export const pillStyles = (sentiment, truncation, weight) =>
  classify({
    flex: 'inline-flex items-center gap-1',
    width: truncation ? 'max-w-3xs w-fit' : 'w-fit',
    spacing: 'px-2',
    borderRadius: 'rounded',
    typography: 'sh-body-xs sh-all-caps',
    bgColor: bgColor(sentiment, weight),
    textColor: textColor(sentiment, weight),
  })

export const iconStyles = (sentiment, weight) =>
  classify({
    layout: 'w-3 h-3',
    color: iconColor(sentiment, weight),
  })

// truncate will add ... when the pill hits its max width.
// the weird padding vertical aligns the text within the pill (vertically) because the font's line-height is weird.
export const textStyles = truncation => {
  return `${truncation ? 'truncate' : 'text-nowrap'} pb-px pt-[3px]`
}
